function taskReady()
{
  document.body.addEventListener('ajax:success', function(event) {
    if (event.target.classList.contains('edit_task')) {
      var selected_value = parseInt(event.target.querySelector("select").value, 10);
      var count_item = document.getElementById('js-open-count').querySelector(".badge ");
      var current_count = parseInt(count_item.innerHTML, 10);
      if (isNaN(selected_value)) {
        current_count++;
      }
      else {
        if (current_count > 0) {
          current_count--;
        }
      }

      count_item.innerHTML = current_count;
      var other_id;
      if (event.target.id.startsWith('month_')) {
        other_id = event.target.id.replace("month_", "open_");
      } else {
        other_id = event.target.id.replace("open_", "month_");
      }

      var other_form = document.getElementById(other_id);
      if (other_form) {
        other_form.querySelector("select").value = event.target.querySelector("select").value;
      }
    }
  });
  $(document).on('input propertychange', '.js-user-external', function() {
    $(this).closest('form').find('.js-user-select').prop('disabled', $(this).val() !== '');
  });
  $(document).on('change', ".js-user-select", function() {
    $(this).closest('form').find('.js-user-external').prop('disabled', $(this).prop('selectedIndex') !== 0);
  });
}

document.addEventListener('turbolinks:load', taskReady);
